import type { PoiBasicInfoState, PoiLocationState } from '@/shared/api/types/poi-types'
import { VIETNAM_MAP_CENTER } from '@/shared/constants/map'
import { POI_TYPES } from '@/shared/constants/poi-type'

/** Where the location picker starts (and what counts as "untouched" for the create draft/dirty check). */
export const DEFAULT_POI_LOCATION: PoiLocationState = {
  ...VIETNAM_MAP_CENTER,
  range: 1,
  address: '',
}

/**
 * Baseline basic info used to decide whether a draft has content: no type chosen yet.
 * (The form itself opens with `INITIAL_POI_BASIC_INFO`, i.e. type pre-selected to MAJOR.)
 */
export const DEFAULT_POI_BASIC_INFO: PoiBasicInfoState = {
  category: '',
  type: '',
  popupAd: false,
  range: 1,
}

/** Basic info the create form opens with: a major POI is the common case, so it is pre-selected. */
export const INITIAL_POI_BASIC_INFO: PoiBasicInfoState = {
  ...DEFAULT_POI_BASIC_INFO,
  type: POI_TYPES.MAJOR,
}

/** Page size of the category dropdown in the POI form (it loads more on scroll). */
export const POI_FORM_CATEGORY_PAGE_SIZE = 10
